export const FILTERS = {
  PROTEINS: 'proteins',
  DIETS: 'diets',
  PREFERENCES: 'preferences',
  CUISINES: 'cuisines',
  CHEFS: 'chefs',
  PRODUCT_TYPE: 'categories',
  SORT_BY: 'sort_by',
  PROFILES: 'profiles',
  AVOID: 'avoids'
}

export const FILTER_BY_AVAILABLE_VIEWS = {
  BUTTONS: 'filterByButtons',
  CHECKLIST: 'filterByChecklist',
  SORTING: 'filterBySorting',
  PROFILE_PICKER: 'filterByProfilePicker'
}

export const FILTER_BY_VIEWS = {
  [FILTERS.PROTEINS]: FILTER_BY_AVAILABLE_VIEWS.CHECKLIST,
  [FILTERS.DIETS]: FILTER_BY_AVAILABLE_VIEWS.BUTTONS,
  [FILTERS.PREFERENCES]: FILTER_BY_AVAILABLE_VIEWS.BUTTONS,
  [FILTERS.CUISINES]: FILTER_BY_AVAILABLE_VIEWS.BUTTONS,
  [FILTERS.CHEFS]: FILTER_BY_AVAILABLE_VIEWS.BUTTONS,
  [FILTERS.PRODUCT_TYPE]: FILTER_BY_AVAILABLE_VIEWS.CHECKLIST,
  [FILTERS.SORT_BY]: FILTER_BY_AVAILABLE_VIEWS.SORTING,
  [FILTERS.PROFILES]: FILTER_BY_AVAILABLE_VIEWS.PROFILE_PICKER
}

export const SORTING_FILTERS = {
  MY_PREFERENCES: 'My preferences',
  DEFAULT: 'Newest to oldest',
  ALL: 'My preferences'
}

export const FME_SORTING_FILTERS = {
  MY_PREFERENCES: 'My preferences',
  AVG_CUSTOMER_REVIEW: 'Avg. Customer review',
  RECOMMENDED_IN_CATEGORY: 'Recommended in Category',
  CUSTOMER_RATING: 'Customer Rating'
}

export const FILTERS_SECTIONS_TITLES = {
  [FILTERS.PROTEINS]: 'Protein type',
  [FILTERS.DIETS]: 'Diets',
  [FILTERS.PREFERENCES]: 'Preferences',
  [FILTERS.CUISINES]: 'Cuisines',
  [FILTERS.CHEFS]: 'Chefs',
  [FILTERS.PRODUCT_TYPE]: 'Categories',
  [FILTERS.SORT_BY]: 'Sort by',
  [FILTERS.PROFILES]: 'Profiles'
}

export const MACRONUTRIENT_FITLERS = {
  CALORIES: 'calories',
  CARBS: 'carbs',
  PROTEIN: 'protein',
  FAT: 'fat',
  SODIUM: 'sodium',
  SUGAR: 'sugar'
}

export const ALLERGENS_IDS = {
  DAIRY_FREE: 2,
  SOY_FREE: 5,
  TREENUT_FREE: 1,
  PEANUT_FREE: 14
}

export const PREFERENCES_IDS = {
  DAIRY_FREE: 1,
  LOW_CARBS: 2,
  LOW_SUGAR: 3,
  SOY_FREE: 4,
  LOW_FAT: 6,
  LOW_CALORIES: 8,
  LOW_SODIUM: 9,
  NUT_FREE: 10,
  HIGH_PROTEIN: 11
}

export const MACRONUTRIENTS_BY_PREFERENCE_ID = {
  [PREFERENCES_IDS.LOW_CARBS]: {
    name: MACRONUTRIENT_FITLERS.CARBS,
    label: 'Carb Control',
    description: 'Less than 35 g carbs.',
    min: 0,
    max: 35
  },
  [PREFERENCES_IDS.LOW_SODIUM]: {
    name: MACRONUTRIENT_FITLERS.SODIUM,
    label: 'Sodium Wise',
    description: 'Less than 700 mg sodium.',
    min: 0,
    max: 700
  },
  [PREFERENCES_IDS.LOW_CALORIES]: {
    name: MACRONUTRIENT_FITLERS.CALORIES,
    label: 'Calorie Smart',
    description: 'Less than 600 calories.',
    min: 0,
    max: 600
  },
  [PREFERENCES_IDS.HIGH_PROTEIN]: {
    name: MACRONUTRIENT_FITLERS.PROTEIN,
    label: 'Protein Boost',
    description: 'More than 30 g protein.',
    min: 30,
    max: null // Need to be replaced by the max value in the menu
  },
  [PREFERENCES_IDS.LOW_FAT]: {
    name: MACRONUTRIENT_FITLERS.FAT,
    min: 0,
    max: 11
  },
  [PREFERENCES_IDS.LOW_SUGAR]: {
    name: MACRONUTRIENT_FITLERS.SUGAR,
    min: 0,
    max: 4
  }
}
